import GlobalFooter from '@/components/GlobalFooter/GlobalFooter';
import GlobalMinimalFooter, {
  type GlobalMinimalFooterContent,
} from '@/components/GlobalMinimalFooter/GlobalMinimalFooter';
import type {
  Footer as FooterContent,
  GlobalFooterContent,
} from '@/contentful';
import type { userLocationInterface } from '@/hooks/geo';
import LegacyFooter from '../Legacy/Footer/Footer';

interface FooterProps extends userLocationInterface {
  footer:
    | FooterContent
    | GlobalFooterContent
    | GlobalMinimalFooterContent
    | undefined;
}

export default function FooterComponent({
  footer,
  userLocation,
  setUserLocation,
}: FooterProps) {
  if (!footer) return null;

  switch (footer.sys.contentType.sys.id) {
    case 'globalMinimalFooter':
      return (
        <GlobalMinimalFooter content={footer as GlobalMinimalFooterContent} />
      );
    case 'globalFooter':
      return (
        <GlobalFooter
          content={footer as GlobalFooterContent}
          userLocation={userLocation}
          setUserLocation={setUserLocation}
        />
      );
    case 'footer': {
      return <LegacyFooter content={footer as FooterContent} />;
    }
    default:
      return null;
  }
}
